import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRouteConstants } from 'app/shared/constants/api.constants';
import { Observable, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class ChatConversationAPIService {
  private createUpdateSubject = new Subject<any>();

  constructor(private readonly httpClient: HttpClient) {}

  // This should be added to all the CRUD screens where
  sendCRUDUpdate(message: string) {
    //the component that wants to update something, calls this fn
    this.createUpdateSubject.next({ text: message }); //next() will feed the value in Subject
  }

  getCRUDUpdate(): Observable<any> {
    //the receiver component calls this function
    return this.createUpdateSubject.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
  }

  public create(record) {
    const uri = ApiRouteConstants.CHATCONVERSATION.CREATE;
    return this.httpClient
      .post(uri, record)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public update(record, chatConversationId) {
    let uri = ApiRouteConstants.CHATCONVERSATION.UPDATE;
    uri = uri.replace('CHATCONVERSATIONID', chatConversationId);
    return this.httpClient
      .put(uri, record)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public getAll() {
    let uri = ApiRouteConstants.CHATCONVERSATION.GETALL;
    return this.httpClient
      .get(uri)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public getByChatConversationId(chatConversationId) {
    let uri = ApiRouteConstants.CHATCONVERSATION.GETBYID;
    uri = uri.replace('CHATCONVERSATIONID', chatConversationId);
    return this.httpClient
      .get(uri)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public getByUserId(userId) {
    let uri = ApiRouteConstants.CHATCONVERSATION.GETBYUSERID;
    uri = uri.replace('USERID', userId);
    return this.httpClient
      .get(uri)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public getByPartnerId(partnerId) {
    let uri = ApiRouteConstants.CHATCONVERSATION.GETBYPARTNERID;
    uri = uri.replace('PARTNERID', partnerId);
    return this.httpClient
      .get(uri)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }

  public getByLastMessage(lastMessage) {
    let uri = ApiRouteConstants.CHATCONVERSATION.GETBYLASTMESSAGE;
    uri = uri.replace('LASTMESSAGEID', lastMessage);
    return this.httpClient
      .get(uri)
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }
  public readMessagesByConversationId(conversationId, userId) {
    let uri = ApiRouteConstants.CHATCONVERSATION.READMESSAGES;
    uri = uri.replace('CONVERSATIONID', conversationId);
    uri = uri.replace('USERID', userId);
    return this.httpClient
      .post(uri, '')
      .toPromise()
      .catch((err) => {
        throw err;
      });
  }
}
